exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "th[data-v-3bdf9d7f]{padding:1.25rem;text-align:left;font-size:.75rem;line-height:1rem;font-weight:700;text-transform:uppercase;letter-spacing:.05em;--tw-text-opacity:1;color:rgba(80,95,115,var(--tw-text-opacity))}", ""]);

// exports
